export default __webpack_public_path__ + "static/media/SeminarioIes2026_DianaJoels.1ebb20d8.jpg";